export default {
  getItem,
  setItem,
};

export function getItem(
  key: string,
  done: (err: any, value: any) => void
): void {
  let value = window.localStorage[key];
  if (value) {
    try {
      value = JSON.parse(value);
    } catch (e) {
      /* ignore */
    }
  }
  done(null, value);
}
export function setItem(
  key: string,
  value: any,
  done?: (err: any) => void
): void {
  window.localStorage[key] = JSON.stringify(value);
  done && done(null);
}
